import * as types from '../../mutation-types'
import timesheet from './timesheet'
import mailPayment from './mailPayment'
import user from './user'
import team from './team'
import changePassword from './changePassword'
import dayOff from './dayoff'
import general from './general'
import payslip from './payslip'
import news from './news'
import budget from './budget'
import allowance from './allowance'

// show: meta.label -> name
// name: component name
// meta.label: display label

const state = {
  items: [
    timesheet,
    dayOff,
    user,
    team,
    payslip,
    allowance,
    changePassword
  ]
}

const mutations = {
  [types.EXPAND_MENU] (state, menuItem) {
    if (menuItem.index > -1) {
      if (state.items[menuItem.index] && state.items[menuItem.index].meta) {
        state.items[menuItem.index].meta.expanded = menuItem.expanded
      }
    } else if (menuItem.item && 'expanded' in menuItem.item.meta) {
      menuItem.item.meta.expanded = menuItem.expanded
    }
  }
}

export default {
  state,
  mutations
}



// WEBPACK FOOTER //
// ./client/store/modules/menu/index.js